<div mat-dialog-content>
  <div class="container" align="center">
    <h1 mat-dialog-title><strong>Máquina Cadastrada</strong></h1>
    <p>
      Sua máquina foi cadastrada com sucesso! <br />
      Foi gerado um token de segurança para esta máquina e você deve guardá-lo para <br />
      possíveis solicitações deste Token no momento do Envio SEFIP. Baixe o para continuar o Envio.<br />
    </p>
  </div>
</div>
<div mat-dialog-actions class="botoes">
  <button mat-raised-button class="md-icon-button btnOK" (click)="baixarToken()" cdkFocusInitial>
    <img class="img-fluid" src="assets/icons/save_alt_white.png" width="24px" /> Baixar Token
  </button>
</div>